import { SpotTableauFileStructureViewBaseIcon } from '@tableau/icons/SpotTableauFileStructureViewBaseIcon';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { CardResizerService } from '~src/spacesPlatform/services/CardResizerService';
import { VizLoadContextService, VizLoadType } from '~src/viz/services/VizLoadContextService';

import { ViewTooltip } from './ViewTooltip';

export const getViewDefaultImageUrl = () => imgPath('spaces_card_view.svg');

export class ViewCard extends ContentCard {
  public render() {
    const {
      content, inRecentsSpace, urls, hovered, selected, allowDragAndDrop, addContentFavorite, removeContentFavorite
    } = this.props;
    const showLastAccessedAt = inRecentsSpace || this.props.showLastAccessedAt;

    return (
      <div className={CardViewStyles.Card}>
        <Thumbnail
          navigateUrl={getContentUrlForItem(content, urls)}
          defaultImageUrl={getViewDefaultImageUrl()}
          defaultImageNode={<SpotTableauFileStructureViewBaseIcon size={60} />}
          thumbnailImageUrl={content.thumbnailUrl}
          hovered={hovered}
          selected={selected}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
          onNavigate={() => VizLoadContextService.set(VizLoadType.ThumbnailClick)}
          contentType={'view'}
        />
        <div className={CardViewStyles.ActionRow} style={this.getCardZoomStyleForActionRow()}>
          <CardTitle name={content.name} data-tb-test-id="view-name" />
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.viewTooltipTitle()}
            />
          </span>
          <span>
            <FavoriteToggle isTabbable={true}
              isFavorite={content.favorite}
              itemName={content.name}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'view' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'view' })} />
          </span>
          {this.renderActionsMenu()}
        </div>
        {
          showLastAccessedAt ? (
            <div className={CardViewStyles.CardLastAccessedAt + (CardResizerService.instance.shouldUseCompactCardTitle() ? (' ' + CardViewStyles.CardNoLeftPadding) : '')}>
              {this.getLastAccessedAt()}
            </div>
          ) : (
            this.shouldRenderExtraInformationAtBottom() &&
            <div className={CardViewStyles.CardDescription}>
              {this.getDescription()}
            </div>
          )
        }
      </div>
    );
  }

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    return ViewTooltip;
  }
}
